import {
    GET_ASSET_FLEET_HEADER_DETAILS,
    GET_ASSET_FLEET_ITEM_DETAILS,
    GET_ASSET_FLEET_TASK_DETAILS,
    GET_ASSET_OREDR_HEADER_DETAILS,
    SAVE_ASSET_ASSIGNED_TO_FOR_ALL_ITEM,
    SET_ASSET_FLEET_HEADER_DETAILS,
    SET_ASSET_FLEET_ITEM_DETAILS,
    SET_ASSET_FLEET_TASK_DETAILS,
    SET_ASSET_OREDR_HEADER_DETAILS,
    SET_ASSET_ASSIGNED_TO_FOR_ALL_ITEM,
    SET_ASSET_OPEN_ACCORDION_LIST,
    GET_AFE_FLEET_HEADER_DETAILS,
    SET_AFE_FLEET_HEADER_DETAILS,
    GET_AFE_FLEET_ITEM_DETAILS,
    SET_AFE_FLEET_ITEM_DETAILS,
    GET_AFE_FLEET_TASK_DETAILS,
    SET_AFE_FLEET_TASK_DETAILS,
    GET_AFE_ORDER_HEADER_DETAILS
} from "./AssetFleetProcessingType"

const getAssetOrderHeaderDetail = (orderId: any) => ({
    type: GET_ASSET_OREDR_HEADER_DETAILS,
    orderId
})

const setAssetOrderHeaderDetail = (assetOrderHeaderDetail: any) => ({
    type: SET_ASSET_OREDR_HEADER_DETAILS,
    assetOrderHeaderDetail: assetOrderHeaderDetail
})

const getAfeOrderHeaderDetail = (orderId: any) => ({
    type: GET_AFE_ORDER_HEADER_DETAILS,
    orderId
})

const setAfeOrderHeaderDetail = (afeOrderHeaderDetail: any) => ({
    type: SET_AFE_FLEET_HEADER_DETAILS,
    afeOrderHeaderDetail
})

const getAssetFleetHeaderDetail = (orderId: any) => ({
    type: GET_ASSET_FLEET_HEADER_DETAILS,
    orderId
})

const setAssetFleetHeaderDetail = (assetFleetHeaderDetail: any) => ({
    type: SET_ASSET_FLEET_HEADER_DETAILS,
    assetFleetHeaderDetail: assetFleetHeaderDetail
})

const getAfeFleetHeaderDetail = (orderId: any) => ({
    type: GET_AFE_FLEET_HEADER_DETAILS,
    orderId
})

const setAfeFleetHeaderDetail = (afeFleetHeaderDetail: any) => ({
    type: SET_AFE_FLEET_HEADER_DETAILS,
    afeFleetHeaderDetail: afeFleetHeaderDetail
})

const getAssetFleetItemDetails = (fleetRequestDetailId: any) => ({
    type: GET_ASSET_FLEET_ITEM_DETAILS,
    fleetRequestDetailId
})

const setAssetFleetItemDetails = (assetFleetItemDetail: any) => ({
    type: SET_ASSET_FLEET_ITEM_DETAILS,
    assetFleetItemDetail: assetFleetItemDetail
})

const getAfeFleetItemDetails = (fleetRequestDetailId: any) => ({
    type: GET_AFE_FLEET_ITEM_DETAILS,
    fleetRequestDetailId
})

const setAfeFleetItemDetails = (afeFleetItemDetail: any) => ({
    type: SET_AFE_FLEET_ITEM_DETAILS,
    afeFleetItemDetail: afeFleetItemDetail
})

const getAssetFleetTaskDetails = (fleetRequestDetailId: any) => ({
    type: GET_ASSET_FLEET_TASK_DETAILS,
    fleetRequestDetailId
})

const setAssetFleetTaskDetails = (assetFleetTaskDetail: any) => ({
    type: SET_ASSET_FLEET_TASK_DETAILS,
    assetFleetTaskDetail: assetFleetTaskDetail
})

const getAfeFleetTaskDetails = (fleetRequestDetailId: any) => ({
    type: GET_AFE_FLEET_TASK_DETAILS,
    fleetRequestDetailId
})

const setAfeFleetTaskDetails = (afeFleetTaskDetail: any) => ({
    type: SET_AFE_FLEET_TASK_DETAILS,
    afeFleetTaskDetail: afeFleetTaskDetail
})

const saveAssetAssignedToForAllItem = (payload: any) => ({
    type: SAVE_ASSET_ASSIGNED_TO_FOR_ALL_ITEM,
    payload
})

const setAssetAssignedToForAllItem = (assetAssignedToForAllItem: any) => ({
        type: SET_ASSET_ASSIGNED_TO_FOR_ALL_ITEM,
        assetAssignedToForAllItem: assetAssignedToForAllItem
})

const setAssetOpenAccordionList = (list: any) => ({
    type: SET_ASSET_OPEN_ACCORDION_LIST,
    list
})

export {
    getAssetOrderHeaderDetail,
    setAssetOrderHeaderDetail,
    getAfeOrderHeaderDetail,
    setAfeOrderHeaderDetail,
    getAssetFleetHeaderDetail,
    setAssetFleetHeaderDetail,
    getAfeFleetHeaderDetail,
    setAfeFleetHeaderDetail,
    getAssetFleetItemDetails,
    setAssetFleetItemDetails,
    getAfeFleetItemDetails,
    setAfeFleetItemDetails,
    getAssetFleetTaskDetails,
    setAssetFleetTaskDetails,
    getAfeFleetTaskDetails,
    setAfeFleetTaskDetails,
    saveAssetAssignedToForAllItem,
    setAssetAssignedToForAllItem,
    setAssetOpenAccordionList
}